import get from "lodash/get";
import React, { forwardRef } from "react";
import OverlaysContext from "./overlaysContext";
const getOverlaysContainer = (context) => () => {
    const overlaysContainerId = get(context || {}, "overlaysContainerId");
    return overlaysContainerId ? document.getElementById(overlaysContainerId) : undefined;
};
export default function withOverlaysContext(WrappedComponent) {
    function WithOverlaysContext(props) {
        const { forwardedRef, context, ...other } = props;
        return (React.createElement(WrappedComponent, { ref: forwardedRef, ...other, overlaysManager: get(context || {}, "overlaysManager"), getOverlaysContainer: getOverlaysContainer(context) }));
    }
    WithOverlaysContext.displayName = `withOverlaysContext(${get(WrappedComponent, "displayName", "")})`;
    const ForwardedWithOverlaysContext = forwardRef((props, ref) => (React.createElement(OverlaysContext.Consumer, null, (context) => (React.createElement(WithOverlaysContext, { ...props, context: context, forwardedRef: ref })))));
    ForwardedWithOverlaysContext.displayName = `forwardedWithOverlaysContext(${get(WrappedComponent, "displayName", "")})`;
    return ForwardedWithOverlaysContext;
}
